import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_JOURNALS } from '@/api/endpoints';
import { JOURNALS_QUERY_KEY } from '@/api/queryKeys';
import { sortJournals } from '@/utils/journal';
import type { Journal } from '@/types/journal';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useJournals = () =>
  useQuery({
    queryKey: JOURNALS_QUERY_KEY,
    queryFn: () =>
      apiClient
        .get<Journal[]>(API_JOURNALS)
        .then(unwrapAxiosResponse)
        .then(sortJournals),
  });
